import { DrawerWithIcon } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const Drawer = styled(DrawerWithIcon)`
  & .drawer-content {
    overflow-x: hidden;
  }
`
